/* istanbul ignore file */
import { LinkButton, LinkButtonProps } from 'framework/ui/ui-builder';
import { useAuthorization } from 'framework/authorization';
import { useFieldHelper } from 'framework/ui/field';
import { useSkillBasedQueueUrl } from 'domain/gpo/skillBasedQueue/skillBasedQueueRoute';

interface CopySkillBasedQueueButtonProps extends Omit<LinkButtonProps, 'url'> {
  value?: StringOrNumber;
  permissionToCheck?: string;
}

const CopySkillBasedQueueButton = ({ permissionToCheck, ...props }: CopySkillBasedQueueButtonProps) => {
  const { getCopyEntityUrl } = useSkillBasedQueueUrl();
  const { getValue: getId } = useFieldHelper(props);
  const id = getId();
  const { isGranted } = useAuthorization();

  return !permissionToCheck || isGranted(permissionToCheck) ? (
    <LinkButton {...props} url={getCopyEntityUrl(id)}>
      Copy
    </LinkButton>
  ) : null;
};

export default CopySkillBasedQueueButton;
